// TODO refactor
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VALIDATOR_EMAIL } from '../../utils/validators';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Card from '../../components/UI/Card/Card';
import ErrorModal from '../../components/UI/ErrorModal/ErrorModal';
import LoadingSpinner from '../../components/UI/LoadingSpinner/LoadingSpinner';
import '../Login/Login.css';
import Athenalogo from '../../assets/images/Athena_logo_final.png';
import { SupportInfo } from '../../components/SupportInfo/SupportInfo';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import SuccessIcon from '../../assets/images/submit-register-icon.svg?react';

export const ForgotPassword = () => {
  const [count, setCount] = useState(0);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: '',
        isValid: false
      }
    },
    false
  );
  const navigate = useNavigate();

  const switchToReset = () => {
    navigate('/login');
  };

  const switchModeHandler = () => {
    setFormData(
      {
        ...formState.inputs
      },
      false
    );
    navigate('/login');
  };

  const authSubmitHandler = async (event) => {
    event.preventDefault();

    try {
      const response = await sendRequest(
        import.meta.env.VITE_BACKEND_URL + `/api/users/forgotPassword`,
        'POST',
        JSON.stringify({
          email: formState.inputs.email.value
        }),
        {
          'Content-Type': 'application/json'
        }
      );

      if (response.user) {
        setCount((prevCount) => prevCount + 1);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const disabledCheck = () => {
    let disabled;
    let mess;
    let style = {};
    if (count === 0) {
      disabled = !formState.inputs.email.isValid;

      mess = 'Next';
    }

    if (count === 1) {
      style = { display: 'none' };
    }
    return [disabled, mess, style];
  };

  return (
    <>
      <div className="auth-container">
        <ErrorModal error={error} onClear={clearError} />
        {isLoading && (
          <div className="center" style={{ clear: 'both' }}>
            <LoadingSpinner />
          </div>
        )}
        {!isLoading && (
          <Card className="authentication">
            <img src={Athenalogo} alt="logo" />

            <p className="headline">Forgot password?</p>
            <form onSubmit={authSubmitHandler}>
              {count === 0 && (
                <>
                  <div className="info">
                    <p>Enter e-mail address you use for your Athena account</p>
                  </div>
                  <Input
                    element="input"
                    id="email"
                    type="email"
                    placeholder="E-Mail"
                    validators={[VALIDATOR_EMAIL()]}
                    errorText="Please enter a valid email address."
                    onInput={inputHandler}
                  />
                </>
              )}
              {count === 1 && (
                <>
                  <div>
                    <SuccessIcon />
                  </div>
                  <div className="info" style={{ textAlign: 'center' }}>
                    <p>Thank You. Please check your email account.</p>
                  </div>
                  <Button onClick={switchModeHandler}>{'LOG IN'}</Button>
                </>
              )}

              <div className="button-submit" style={disabledCheck()[2]}>
                <Button type="submit" disabled={disabledCheck()[0]}>
                  {disabledCheck()[1]}
                </Button>
              </div>
            </form>
            {count < 2 && (
              <>
                <button inverse onClick={switchToReset}>
                  Login instead
                </button>
              </>
            )}
          </Card>
        )}
        <SupportInfo />
      </div>
    </>
  );
};
